import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ListLoader } from '../../components/list-loader/list-loader';
import { Router } from '@angular/router';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ComparatorService } from '../../services/comparator-service';
import { GbplanMasterDetailEntry } from '../../../core/av-api';
import { TableSortModel } from '../../tablesort/tableSortModel';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundbuchplaene-table',
  templateUrl: './grundbuchplaene-table.component.html',
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, KompaktTimepointComponent, TranslatePipe]
})
export class GrundbuchplaeneTableComponent extends AbstractComponent {
  private _listLoader: ListLoader<GbplanMasterDetailEntry>;
  private tableSortModel = new TableSortModel<GbplanMasterDetailEntry>('table', this.comparatorService);

  @Input()
  hasRight = true;

  constructor(
    protected router: Router,
    protected appformatConfigService: FormatConfigService,
    protected comparatorService: ComparatorService
  ) {
    super();
    this.tableSortModel
      .addColumn('planNummer', (a, b) => this.comparatorService.gbplanMasterDetailEntryComparator(a, b), undefined)
      .switchSortDirection();
  }

  @Input()
  set listLoader(listLoader: ListLoader<GbplanMasterDetailEntry>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<GbplanMasterDetailEntry> {
    return this._listLoader;
  }
}
